<template>
  <div :class="$style.wrapper">
    <canvas :class="$style.canvas" ref="canvas"></canvas>
    <Selection
      v-show="url"
      v-for="(line, index) in value.lines"
      :key="line.id"
      :class="getClassName(index)"
      :title="line.title"
      :vertical="line.vertical"
      :length="line.length"
      :left="line.left"
      :top="line.top"

      @resize="onResize(line, $event)"
    />

  </div>
</template>

<script>
import Selection from './Selection'
import { drawImage } from 'canvas-object-fit';

export default {
  props: ['value', 'url'],
  components: {
    Selection
  },
  data() {
    return {
      image: new Image(),
      context: null
    }
  },
  methods: {
    getClassName(i) {
      const key = 'line-' + i
      return this.$style[key]
    },
    load() {
      this.$refs.canvas.width = this.$refs.canvas.offsetWidth;
      this.$refs.canvas.height = this.$refs.canvas.offsetHeight

      setTimeout(() => drawImage(
        this.context,
        this.image,
        0, 0, this.$refs.canvas.offsetWidth, this.$refs.canvas.offsetHeight,
        { objectFit: 'contain' }
      ));
    },
      onResize(activeLine, position) {
      console.log(position)

      this.$emit('input', {
        ...this.value,
        lines: this.value.lines.map(line => line == activeLine
          ? { ...line, ...position }
          : line
        )
      })
    },
  },
  watch: {
    url() {
      if (this.url) {
        this.image = new Image()
        this.image.src = this.url
        this.image.onload = this.load
      } else {
        this.context.clearRect(
          0, 0,
          this.$refs.canvas.width,
          this.$refs.canvas.height
        )
      }
    }
  },
  mounted() {
    this.context = this.$refs.canvas.getContext('2d')
    if (this.url) {
      this.image = new Image()
      this.image.src = this.url
      this.image.onload = this.load
    }
  }
}
</script>

<style module lang="scss" >
.wrapper {
  position: relative;
  background-color: #eee;
  height: 100%;

  @media (min-width: 768px) {
    padding-bottom: 100%;
    height: auto;
  }
}

.canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.line-0 {
  top: 35%;
  left: 40%;
}

.line-1 {
  top: 40%;
  left: 40%;
}

.line-2 {
  top: 55%;
  left: 40%;
}

.line-3 {
  top: 20%;
  left: 70%;
}

</style>
